import Swiper from 'swiper';
import tippy from 'tippy.js';
export * from 'swiper';


require('../bundle.js');


const applyScrollAnimeClass = (elem, clazz) => {
  const className = elem.getAttribute(`data-scroll-anime-${clazz}`);

  if (!className) {
    elem.style.animationPlayState = 'running';
  }
  else {
    if (!elem.classList.contains(className)) {
      elem.classList.add(className);
    }
  }
}

const removeScrollAnimeClass = (elem, clazz) => {
  const className = elem.getAttribute(`data-scroll-anime-${clazz}`);
  if (!className) {
    elem.style.animationPlayState = 'paused';
  }
  else {
    if (elem.classList.contains(className)) {
      elem.classList.remove(className);
    }
  }
}



/**
 * 要素が見えたらアニメーションを開始する
 * 
 *  data-scroll-anime-class: 付与するcssクラス名
 *  data-scroll-anime-anchor: 自身ではなく、この要素が見えた時にアニメーションを開始する
 *  data-scroll-anime-on: クラス名を付与する (data-scroll-anime-on=false で付与しない)
 *  data-scroll-anime-off: 見えなくなった時にクラス名を削除する
 * 
 */
const doAnimationByScroll = () => {
  const scrollAnimeElems = document.querySelectorAll('[data-scroll-anime-class]');

  const option = {
    root: null,
    rootMargin: '-10% 0px',
    threshold: 0,
  }

  const observe = entries => {
    entries.forEach(entry => {
      const elems = entry.target?.dataScrollAnimeTargets;
      if (!elems) {
        return;
      }

      if (entry.isIntersecting) {
        elems.on.forEach(elem => {
          applyScrollAnimeClass(elem, 'class');
        });
      }
      else {
        elems.off.forEach(elem => {
          removeScrollAnimeClass(elem, 'class');
        });
      }
    });
  }

  const observer = new IntersectionObserver(observe, option);
  scrollAnimeElems.forEach(elem => {
    const anchor = elem.getAttribute('data-scroll-anime-anchor') ?? 'this';
    const useOn = elem.hasAttribute('data-scroll-anime-on') ? elem.getAttribute('data-scroll-anime-on') !== 'true' : true;
    const useOff = elem.hasAttribute('data-scroll-anime-off') ? elem.getAttribute('data-scroll-anime-off') !== 'false' : false;

    let anchorElem = elem;
    if (anchor !== 'this') {
      anchorElem = document.getElementById(anchor);
    }

    if (!anchorElem || (!useOn && !useOff)) {
      return;
    }

    if (!anchorElem.dataScrollAnimeTargets) {
      anchorElem.dataScrollAnimeTargets = {
        on: [],
        off: []
      };
      observer.observe(anchorElem);
    }

    if (useOn) {
      anchorElem.dataScrollAnimeTargets.on.push(elem);
    }
    if (useOff) {
      anchorElem.dataScrollAnimeTargets.off.push(elem);
    }
  });
}


/**
 * 特定の要素〜特定の要素 の間にスクロールがいる場合にアニメーションを開始する 
 * 
 *  data-scroll-anime-range-class: 付与するcssクラス名
 *  data-scroll-anime-on-anchor: 自この要素が見えた時にアニメーションを開始する
 *  data-scroll-anime-off-anchor:  この要素が見えた時にアニメーションを停止する
 *  data-scroll-anime-offset: top|middle|bottom|infinite|[script-value] 見えたと判断する位置
 */
const doAnimationByScrollRange = () => {
  const rangeElements = document.querySelectorAll('[data-scroll-anime-range-class]');

  const evalOffsetValue = (offsetValue, bounds) => {
    let value = 0;

    switch (offsetValue) {
      case 'top': value = 0; break;
      case 'middle': value = -window.innerHeight / 2; break;
      case 'bottom': value = -window.innerHeight; break;
      case 'infinite': value = Number.MAX_SAFE_INTEGER - 10000; break;
      default:
        const temp = eval(offsetValue);
        value = !isNaN(temp) ? temp : 0;
    }

    return value;
  }

  const runAnimation = (e) => {
    // range
    rangeElements.forEach(elem => {
      const anchor = {
        on: 'this', off: 'this'
      }

      if (elem.hasAttribute('data-scroll-anime-anchor')) {
        anchor.on = anchor.off = elem.getAttribute('data-scroll-anime-anchor');
      }
      else {
        anchor.on = elem.getAttribute('data-scroll-anime-on-anchor') ?? 'this';
        anchor.off = elem.getAttribute('data-scroll-anime-off-anchor') ?? 'this';
      }

      const anchorElem = { on: elem, off: elem };
      if (anchor.on !== 'this') {
        anchorElem.on = document.getElementById(anchor.on) ?? elem;
      }
      if (anchor.off !== 'this') {
        anchorElem.off = document.getElementById(anchor.off) ?? elem;
      }

      const scrollTop = e?.target?.scrollTop || window.pageYOffset || document.documentElement.scrollTop;
      const bounds = {
        on: anchorElem.on.getBoundingClientRect(),
        off: anchorElem.off.getBoundingClientRect()
      };

      let offsetOnValue = 0;
      let offsetOffValue = 0;
      if (elem.hasAttribute('data-scroll-anime-offset')) {
        offsetOnValue = offsetOffValue = evalOffsetValue(elem.getAttribute('data-scroll-anime-offset'), bounds);
      }
      else {
        offsetOnValue = evalOffsetValue(elem.getAttribute('data-scroll-anime-on-offset'), bounds);
        offsetOffValue = evalOffsetValue(elem.getAttribute('data-scroll-anime-off-offset'), bounds);
      }

      const triggerPoint = {
        on: bounds.on.top + scrollTop + offsetOnValue,
        off: bounds.off.top + scrollTop + offsetOffValue
      }

      if (triggerPoint.on <= scrollTop && scrollTop < triggerPoint.off) {
        applyScrollAnimeClass(elem, 'range-class');
      }
      else {
        removeScrollAnimeClass(elem, 'range-class');
      }
    });
  }

  window.addEventListener('scroll', e => runAnimation(e), true);
  window.addEventListener('resize', runAnimation);
  runAnimation();
}


export function useAnimationByScroll() {
  doAnimationByScroll();
  doAnimationByScrollRange();
}

///////////////////////////////////
// 成分情報をホバー表示する
export function useIngredientTips(className, mode) {
  const elemIngredientItems = document.getElementsByClassName(className);
  const ingredientDescriptions = {
    lotion: {
      '水': '基剤',
      'リンゴ幹細胞培養エキス': '植物幹細胞成分です。皮膚にうるおいを与えます。',
      'グリチルリチン酸２K': '皮膚の炎症を抑え、キメを整えます。',
      'スフィンゴ糖脂質': '皮膚のバリア機能に働きかける成分です。',
      'アラントイン': '皮膚の炎症を抑え、キメを整えます。',
      'イノシトール': '皮膚の油分のバランスを整えるために配合しています。',
      'トレハロース': '皮膚表面に残り、さらっとした皮膚質へと導きます。',
      'グリセリン': '皮膚表面を保護し、皮膚にうるおいを与えます。',
      'イソマルト': '皮膚表面に残り、さらっとした皮膚質へと導きます。',
      'タウリン': '人も持っている成分で、保湿性に優れています。',
      'リシンHCl': '美肌成分プラセンタの構成アミノ酸です。',
      'アラニン': '美肌成分プラセンタの構成アミノ酸です。',
      'アルギニン': '美肌成分プラセンタの構成アミノ酸です。',
      'ヒスチジンHCl': '筋肉中に存在する成分の構成成分です。',
      'セリン': '角質に存在する天然保湿因子中に最も多く含まれるアミノ酸です。',
      'プロリン': '体のエネルギー源として使われるアミノ酸です。',
      'グルタミン酸': 'リラックス成分GABAを生成するためのアミノ酸です。',
      'トレオニン': '動物性たんぱく質に多く含まれるコラーゲン合成の材料アミノ酸です。',
      'バリン': 'B.C.A.A.の筆頭成分です。筋肉強化、疲労回復、エラスチンの構成するアミノ酸です。',
      'ロイシン': '美肌成分プラセンタの構成アミノ酸です。 B.C.A.A.の一つでもあります。',
      'グリシン': '強いキレート効果を持ち、酸化ストレスから守るアミノ酸です。',
      'イソロイシン': '美肌成分プラセンタの構成アミノ酸です。 B.C.A.A. の一つでもあります。',
      'フェニルアラニン': '美肌成分プラセンタの構成アミノ酸です。',
      'ジラウロイルグルタミン酸リシンNa': '植物性脂肪酸とアミノ酸によって作られた皮膚保護成分で、皮膚にうるおいを与えます。',
      'プロパンジオール': '角質内部に浸透し、皮膚にうるおいを与えます。',
      'キサンタンガム': '粘度調整を行うことで、使い心地を良くしています。',
      'ミリスチン酸ポリグリセリル-10': '植物由来の界面活性剤で、皮膚に潤いを与えます。',
      'カプリルヒドロキサム酸': 'キレート効果により、微生物から商品を守っています。',
    },
    cream: {
      '水': '基剤',
      'セラミドNG': 'セラミドの１種で、毛髪にツヤ、まとまりを与えます。',
      'リンゴ幹細胞培養エキス': '植物幹細胞成分です。皮膚にうるおいを与えます。',
      'グリチルレチン酸ステアリル': '皮膚の炎症を抑え、キメを整えます。',
      'スフィンゴ糖脂質': '皮膚のバリア機能に働きかける成分です。',
      'アラントイン': '皮膚の炎症を抑え、キメを整えます。',
      'イソマルト': '皮膚表面に残り、さらっとした皮膚質へと導きます。',
      'γ- ドコサラクトン': '毛の内部に浸透するエモリエントオイルで、毛にツヤとまとまりを与えます。',
      'グリセリン': '皮膚表面を保護し、皮膚にうるおいを与えます。',
      'イソステアリン酸イソステアリル': '毛の内部に浸透するエモリエントオイルで、毛にツヤとまとまりを与えます。',
      'N- オレイルヒドロキシヘキサナミド': '毛の表面を保護するエモリエントオイルで、毛にツヤとまとまりを与えます。',
      'トリ（カプリル酸／カプリン酸）グリセリル': '毛の内部に浸透するエモリエントオイルで、毛にツヤとまとまりを与えます。',
      '水添ナタネ油アルコール': '毛の表面を保護するエモリエントオイルで、毛にツヤとまとまりを与えます。',
      'アルギニン': 'アミノ酸の１種で、毛にうるおいを与えます。',
      'ジラウロイルグルタミン酸リシンNa': '植物性脂肪酸とアミノ酸によって作られた皮膚保護成分で、毛にうるおいを与えます。',
      'ジイソステアリン酸ポリグリセリル-10': '植物由来成分で、毛に潤いを与えます。',
      'プロパンジオール': '角質内部に浸透し、皮膚にうるおいを与えます。',
      'カルボマー': '粘度調整を行うことで、使い心地を良くしています。',
      'カプリルヒドロキサム酸': 'キレート効果により、微生物から商品を守っています。',
    }
  };

  for (let i = 0; i < elemIngredientItems.length; i++) {
    const elem = elemIngredientItems[i];
    const ingredient = elem.innerText;
    const description = ingredientDescriptions[mode][ingredient] ?? '';
    tippy(elem, {
      trigger: 'mouseenter focus click',
      interactive: true,
      content: description,
    });
  }
}